export const duplicateValue = (value: string) => {
  return `${value} (Copy)`;
};
